import React from "react";

export default function PreviewComponent({ selectedFile }) {
  console.log("selectedfile", selectedFile);

  return (
    <>
      {selectedFile ? (
        selectedFile?.mime_type.startsWith("image/") ? (
          <img
            src={selectedFile.data}
            alt={selectedFile.name}
            style={{ width: "100%" }}
          />
        ) : selectedFile?.mime_type === "application/pdf" ? (
          <iframe
            src={selectedFile.data}
            title={selectedFile.name}
            style={{ width: "100%", height: "500px" }}
          />
        ) : (
          <a href={selectedFile.data} download={selectedFile.name}>
            <button className="btn btn-primary">Descargar archivo</button>
          </a>
        )
      ) : null}
    </>
  );
}
